(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collapsing-columns"] && !Shopify.designMode) return;
  try {
    
  function updateDetails() {
    const detailsElements = document.querySelectorAll('.disclosure');
    detailsElements.forEach(details => {
      if (window.innerWidth < 768) {
        details.removeAttribute('open');
      } else {
        details.setAttribute('open', '');
      }
    });
  }

  // Initial check
  updateDetails();

  // Listen for resize events
  window.addEventListener('resize', updateDetails);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-featured-articles"] && !Shopify.designMode) return;
  try {
    
    const list = document.getElementById("blog_list");
    const btn = document.getElementById("readMoreBtn");
    const visibleItemsInput = document.getElementById("visibleItemsCount");

    if (list && visibleItemsInput) {  // Check if both the list and hidden input exist
        let visibleItems = parseInt(visibleItemsInput.value, 10);  // Get value from hidden input
        const items = list.getElementsByTagName("li");

        btn.addEventListener("click", function() {
            let itemsToShow = 4;  // Number of items to show on each click

            for (let i = visibleItems; i < visibleItems + itemsToShow; i++) {
                if (items[i]) {
                    items[i].classList.add("show");
                }
            }

            visibleItems += itemsToShow;

            if (visibleItems >= items.length) {
                btn.style.display = "none";  // Hide button when all items are shown
            }
        });
    } else { 
        if (btn) btn.style.display = "none";  // Hide button if necessary elements are not found
    }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-featured-articles2"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.collection-featured-articles').forEach(function (section) {
    var list = section.querySelector('[data-blog-list]');
    var btn = section.querySelector('[data-load-more]');

    if (!list || !btn) return;

    var ITEMS_PER_CLICK = 4;

    function updateButtonVisibility() {
      var hidden = list.querySelectorAll('li:not(.show)');
      btn.style.display = hidden.length === 0 ? 'none' : '';
    }

    btn.addEventListener('click', function () {
      var hidden = Array.prototype.slice.call(list.querySelectorAll('li:not(.show)'), 0, ITEMS_PER_CLICK);
      hidden.forEach(function (li) {
        li.classList.add('show');
      });
      updateButtonVisibility();
    });

    updateButtonVisibility();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-featured-container-articles-pages"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.collection-featured-articles').forEach(function (section) {
    var list = section.querySelector('[data-blog-list]');
    var btn = section.querySelector('[data-load-more]');

    if (!list || !btn) return;

    var ITEMS_PER_CLICK = 4;

    function updateButtonVisibility() {
      var hidden = list.querySelectorAll('li:not(.show)');
      btn.style.display = hidden.length === 0 ? 'none' : '';
    }

    btn.addEventListener('click', function () {
      var hidden = Array.prototype.slice.call(list.querySelectorAll('li:not(.show)'), 0, ITEMS_PER_CLICK);
      hidden.forEach(function (li) {
        li.classList.add('show');
      });
      updateButtonVisibility();
    });

    updateButtonVisibility();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-articles"] && !Shopify.designMode) return;
  try {
    
    const list = document.getElementById("blog_list");
    const btn = document.getElementById("readMoreBtn");
    const visibleItemsInput = document.getElementById("visibleItemsCount");

    if (list && visibleItemsInput) {  // Check if both the list and hidden input exist
        let visibleItems = parseInt(visibleItemsInput.value, 10);  // Get value from hidden input
        const items = list.getElementsByTagName("li");

        btn.addEventListener("click", function() {
            let itemsToShow = 4;  // Number of items to show on each click

            for (let i = visibleItems; i < visibleItems + itemsToShow; i++) {
                if (items[i]) {
                    items[i].classList.add("show");
                }
            }

            visibleItems += itemsToShow;

            if (visibleItems >= items.length) {
                btn.style.display = "none";  // Hide button when all items are shown
            }
        });
    } else { 
        if (btn) btn.style.display = "none";  // Hide button if necessary elements are not found
    }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-blog"] && !Shopify.designMode) return;
  try {
    
    const list = document.getElementById("blog_list");
    const btn = document.getElementById("readMoreBtn");
    const visibleItemsInput = document.getElementById("visibleItemsCount");

    if (list && visibleItemsInput) {  // Check if both the list and hidden input exist
        let visibleItems = parseInt(visibleItemsInput.value, 10);  // Get value from hidden input
        const items = list.getElementsByTagName("li");

        btn.addEventListener("click", function() {
            let itemsToShow = 4;  // Number of items to show on each click

            for (let i = visibleItems; i < visibleItems + itemsToShow; i++) {
                if (items[i]) {
                    items[i].classList.add("show");
                }
            }

            visibleItems += itemsToShow;

            if (visibleItems >= items.length) {
                btn.style.display = "none";  // Hide button when all items are shown
            }
        });
    } else { 
        if (btn) btn.style.display = "none";  // Hide button if necessary elements are not found
    }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
      
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();
        if(this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }
      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }
    customElements.define('nav-menu', NavMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-blog"]) return;
  try {
    
    // Select all the span elements
    const spans = document.querySelectorAll('.read-more-btn');
    
    // Add click event listener to each span
    spans.forEach(span => {
      span.addEventListener('click', function() {
        const textElement = this.previousElementSibling; // Find the corresponding text (previous sibling)
    
        if (textElement.classList.contains('expanded')) {
          textElement.classList.remove('expanded');
          this.textContent = this.getAttribute('data-read-more');
        } else {
          textElement.classList.add('expanded');
          this.textContent = this.getAttribute('data-read-less');
        }
      });
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["orders-list"] && !Shopify.designMode) return;
  try {
     
  document.addEventListener("DOMContentLoaded", function () {
    var drawer = document.querySelector('side-drawer[data-name="order"]');
    var overlay = document.querySelector(".js-overlay");
    var body = document.body;
  
    var scrollPosition = 0; // Store scroll position
  
    if (drawer && overlay) {
      var closeDrawerBtn = drawer.querySelector(".js-close-drawer");
  
      if (closeDrawerBtn) {
        closeDrawerBtn.addEventListener("click", function () {
          drawer.setAttribute("aria-hidden", "true");
          drawer.removeAttribute("open");
          overlay.classList.remove("is-visible");
  
          // Restore the body's scroll position and style
          body.style.position = '';
          body.style.top = '';
          window.scrollTo(0, scrollPosition);
        });
      }
  
      overlay.addEventListener("click", function () {
        drawer.setAttribute("aria-hidden", "true");
        drawer.removeAttribute("open");
        overlay.classList.remove("is-visible");
  
        body.style.position = '';
        body.style.top = '';
        window.scrollTo(0, scrollPosition);
      });
  
      var modifyButtons = document.querySelectorAll(".modifier-btn");
  
      modifyButtons.forEach(function (button) {
        button.addEventListener("click", function (e) {
          e.preventDefault();
  
          var orderId = this.getAttribute("data-order-id");
          var orderStatus = this.getAttribute("data-order-status");
          var orderTotal = this.getAttribute("data-order-total");
  
          document.getElementById("drawerOrderId").textContent = orderId;
          document.getElementById("drawerOrderStatus").textContent = orderStatus;
          document.getElementById("drawerOrderTotal").textContent = orderTotal;
  
          drawer.setAttribute("aria-hidden", "false");
          drawer.setAttribute("open", "");
  
          overlay.classList.add("is-visible");
  
          // Save the current scroll position
          scrollPosition = window.pageYOffset;
  
          // Prevent scrolling by fixing the body's position
          body.style.position = 'fixed';
          body.style.top = `-${scrollPosition}px`;
        });
      });
    }
  }); 

  } catch(e) { console.error(e); }
})();
})();
